import {
  Building2,
  CheckCircle2,
  Puzzle,
  ShoppingBag,
  Smile,
  Sparkles,
  Truck,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type AIConfigurationStepId =
  | 'capabilities'
  | 'restaurant'
  | 'orders'
  | 'fulfillment'
  | 'additional'
  | 'personality'
  | 'review';

export type AIConfigurationStepDefinition = {
  id: AIConfigurationStepId;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const AI_CONFIGURATION_STEPS: AIConfigurationStepDefinition[] = [
  {
    id: 'capabilities',
    title: 'O que a IA faz',
    description: 'Escolha como deseja que a IA atenda seus clientes: pedidos, reservas, vagas, avaliações e outros recursos.',
    icon: Sparkles,
  },
  {
    id: 'restaurant',
    title: 'Sobre o restaurante',
    description: 'Dados que a IA usa para apresentar o restaurante e responder dúvidas: endereço, horários, contato e pagamento.',
    icon: Building2,
  },
  {
    id: 'personality',
    title: 'Personalidade da IA',
    description: 'Escolha como a atendente virtual conversa com seus clientes.',
    icon: Smile,
  },
  {
    id: 'orders',
    title: 'Pedidos e cardápio',
    description: 'Escolha se a IA registra pedidos na conversa ou apenas envia o link do cardápio.',
    icon: ShoppingBag,
  },
  {
    id: 'fulfillment',
    title: 'Entrega e retirada',
    description: 'Configure prazos, taxas e como o pedido chega ao cliente.',
    icon: Truck,
  },
  {
    id: 'additional',
    title: 'Recursos adicionais',
    description: 'Conecte reservas, avaliações, vagas e outros atendimentos.',
    icon: Puzzle,
  },
  {
    id: 'review',
    title: 'Revisar e publicar',
    description: 'Confira o que a IA fará e corrija o que ainda precisa de atenção.',
    icon: CheckCircle2,
  },
];

export const getAIConfigurationStep = (id: AIConfigurationStepId) =>
  AI_CONFIGURATION_STEPS.find((step) => step.id === id) || AI_CONFIGURATION_STEPS[0];
